/**
 * @fileoverview DELETE handler for the "/apps/catalogs/:catalog_id/subscriptions_delete_all" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdSubscriptionsDeleteAllCacheKeys } from "./constants";
import type {
  DeleteAppsCatalogsCatalogIdSubscriptionsDeleteAllProps,
  AppsCatalogsCatalogIdSubscriptionsDeleteAllResult,
} from "./types";

export const deleteAppsCatalogsCatalogIdSubscriptionsDeleteAll = reactQueryMutationAdapter(
  appsCatalogsCatalogIdSubscriptionsDeleteAllCacheKeys,
  (
    props: DeleteAppsCatalogsCatalogIdSubscriptionsDeleteAllProps
  ): Promise<AppsCatalogsCatalogIdSubscriptionsDeleteAllResult> => {
    return fetch(`/apps/catalogs/${props.catalogId}/subscriptions_delete_all`, "DELETE", props);
  }
);
